import { Box, Icon, Flex } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import KulaTextLogo from '@/assets/icons/colored/KulaTextLogo';
import { TradeMarkFooter } from '@/components/trade-mark-footer';

interface PageProps {
  children: ReactNode;
}

const PageRoot = ({ children }: PageProps) => {
  return (
    <Flex
      width="100%"
      bg="linear-gradient(180deg, #FFFFFF 0%, #F3F7FF 100%);"
      p={{
        base: '30px 50px 60px',
        xl: '30px 100px 60px',
        '2xl': '30px 150px 60px',
      }}
      flexDir="column"
    >
      <Box>
        <Icon width="100px" height="60px" as={KulaTextLogo} />
      </Box>
      <Flex
        flex="1"
        border="1px solid var(--kula-dark-secondary-100, #E4E4E7)"
        bg="var(--kula-colors-white, #FFF)"
        borderRadius="24px"
        overflow="auto"
        pos="relative"
      >
        {children}
      </Flex>
    </Flex>
  );
};

const Left = ({ children }: PageProps) => {
  return (
    <Box
      flex="1"
      borderRight="1px solid var(--kula-dark-secondary-100, #E4E4E7)"
    >
      {children}
    </Box>
  );
};

const Right = ({ children }: PageProps) => {
  return (
    <Box flex="1">
      <Box w="100%" h="100%" p="32px">
        {children}
      </Box>
    </Box>
  );
};

export const Page = Object.assign(PageRoot, { Left, Right });

interface PageWithTradeMarkProps {
  children: ReactNode;
  isSignUp?: boolean;
}

export const PageWithTradeMark = ({
  children,
  isSignUp = false,
}: PageWithTradeMarkProps) => {
  return (
    <Flex h="100%" flexDirection="column">
      <Box
        flex="1"
        overflow="auto"
        margin={{
          base: '24px auto',
          xl: '32px auto',
          '2xl': '50px auto',
        }}
      >
        {children}
      </Box>
      <TradeMarkFooter isSignUp={isSignUp} />
    </Flex>
  );
};
